import cmsBrands, { CmsBrandState } from './CmsBrands/cmsbrands.reducer';
import clusters, { Clusters } from './Clusters/clusters.reducer';

import { combineReducers } from 'redux';
import stories, { Stories } from '../Entities/Stories/stories.reducer';
import categories, { CategoryState } from './Categories/categories.reducer';
import brands, { BrandState } from './Brands/brands.reducer';
import products, { ProductState } from './Products/products.reducer';
import media, { MediaState } from './Media/media.reducer';
import outfits, { OutfitsState } from './Outfits/outfits.reducer';
import idols, { IdolState } from './Idols/idols.reducer';
import featuredClusters, {
  FeaturedClusterState,
} from './FeaturedCluster/featured-cluster.reducer';

export interface KeyMap<T> {
  [key: string]: T;
}

export interface EntityStore<T> {
  byId: KeyMap<T>;
}

export interface Entities {
  stories: Stories;
  clusters: Clusters;
  categories: CategoryState;
  brands: BrandState;
  cmsBrands: CmsBrandState;
  products: ProductState;
  media: MediaState;
  outfits: OutfitsState;
  idols: IdolState;
  featuredClusters: FeaturedClusterState;
}

export default combineReducers<Entities>({
  stories,
  clusters,
  categories,
  brands,
  cmsBrands,
  products,
  media,
  outfits,
  idols,
  featuredClusters,
});



// WEBPACK FOOTER //
// ./src/store/Entities/entities.reducer.ts